import { useMutation } from 'hooks/useMutation'
import { useQuery } from 'hooks/useQuery'
import { useQueryClient } from 'hooks/useQueryClient'

import { fetchWorkoutTags, postWorkoutTags } from 'utils/queries/workoutTags'

import { TagGroup } from 'types/workoutTag'

export const useWorkoutTags = () => {
  const queryClient = useQueryClient()

  const tagsQuery = useQuery(['workoutTags'], () => fetchWorkoutTags())

  const postData = useMutation<unknown>(() => postWorkoutTags(), {
    onSuccess: () => queryClient.invalidateQueries('workoutTags', { refetchInactive: true }),
  })

  return {
    postData,
    tags: {
      workoutTypes: tagsQuery.data?.tagGroups[0] as TagGroup,
      muscleGroup: tagsQuery.data?.tagGroups[1] as TagGroup,
      durations: tagsQuery.data?.tagGroups[2] as TagGroup,
      locations: tagsQuery.data?.tagGroups[3] as TagGroup,
    },
  }
}
